export default __webpack_public_path__ + "static/media/personality-small-refresh.2c3ac307.svg";